module.exports = "0.26.0";



//////////////////
// WEBPACK FOOTER
// ./~/autocomplete.js/version.js
// module id = 614
// module chunks = 0